export default "__VITE_ASSET__5dd73efa__"